<app-navigation-header title="Add Group" i18n-title="@@addDeviceGroupMainTab-addGroupTitle" svgName="sl-add">
	<div class="add-device-group-container small-stepper-circles">
		<!-- Add device group header container for current/future/past steps -->
		<div class="horizontal-stepper-label-container">
			<span>
				<app-access-horizontal-stepper-labels [steps]="steps" [currentStep]="currentStep">
				</app-access-horizontal-stepper-labels>
			</span>
			<span class="mat-stepper-navigator">
				@if (isHidden()) {
					<button
						(click)="movePrevious()"
						class="secondary-small-button"
						data-automation-id="add-device-group-back-button"
						i18n="@@addDeviceGroupMainTab-backButton"
					>
						Back
					</button>
				}
				@if (isHidden()) {
					<button
						class="primary-small-button"
						[disabled]="!isValid()"
						(click)="moveNext()"
						data-automation-id="add-device-group-continue-button"
						i18n="@@addDeviceGroupName-continueButton"
					>
						Continue
					</button>
				}
			</span>
		</div>

		@if (currentStep === 0) {
			<div>
				<app-add-device-group-name [companyId]="companyId" [editDeviceGroup]="editDeviceGroup">
				</app-add-device-group-name>
			</div>
		}

		@if (currentStep === 2) {
			<div>
				<app-add-device-group-confirmation
					[deviceGroupId]="editDeviceGroup.id"
					[deviceGroupName]="editDeviceGroup.name"
					[deviceCount]="editDeviceGroup.deviceIds.length"
					[addDeviceGroupRequestStatusEvents]="addDeviceGroupRequestStatusEvents"
				>
				</app-add-device-group-confirmation>
			</div>
		}
	</div>

	@if (currentStep === 1) {
		<div>
			<app-add-device-group-devices [deviceDataRequest]="getAllDevices" [editDeviceGroup]="editDeviceGroup">
			</app-add-device-group-devices>
		</div>
	}
</app-navigation-header>
